export default "/memento-mori/assets/1b4759c627e5fbb7bc1c6f0f68011dd0.mp3";